/**
 * RESPONSIBILITY: the scrolling strip of featured events.
 *
 * Its heading and its events are both on the Events section, so the pencil over this
 * band opens the thing the band is showing.
 */
import { idOf } from '@framework/core';
import type { EventsSection, EventRow } from '@app/sections';
import { EventCard } from './EventCard';

export function EventsFeatured({ c, events }: { c: EventsSection; events: EventRow[] }) {
  if (events.length === 0) return null;

  return (
    <section className="band">
      <div className="wrap">
        <div className="band-head"><h2>{c.featuredHeading}</h2></div>
        <div className="scroller">
          {events.map((e) => <EventCard key={idOf(e)} e={e} wide />)}
        </div>
      </div>
    </section>
  );
}
